import React from 'react'

import makeStyles from '@material-ui/core/styles/makeStyles'
import { useTranslate } from 'react-admin'

import Logo from './images/logo'
import NotFoundSVG from './images/NotFound404'

const useStyles = makeStyles((theme) => ({
  NotFound: {
    width: '100vw',
    height: '100vh',
    zIndex: 10000,
    position: 'fixed',
    top: 0,
    left: 0,
    background: 'white',
    display: 'flex',
    flexFlow: 'column',
    padding: '0% 4% 4% 4%',
    boxSizing: 'border-box',
  },
  header: {
    padding: '3% 2% 1% 2%',
  },
  title: {
    fontWeight: 800,
    fontSize: '35px',
    lineHeight: '50px',
    textAlign: 'center',
    color: '#28282A',
  },
  contentWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: '100%',
  },
  subtitle: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '30px',
    textAlign: 'center',
    color: '#28282A',
    maxWidth: '551px',
  },
  ctaRedirect: {
    marginTop: '30px',
    background: '#F05A26',
    borderRadius: '4px',
    padding: '13px 36px',
    textDecoration: 'auto',
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '16px',
    textAlign: 'center',
  },
  notFoundSVG: {
    width: '85%',
    height: 'auto',
    maxWidth: '440px',
  },
  [theme.breakpoints.down(550)]: {
    header: {
      padding: '3% 2%',
    },
    title: {
      fontSize: '22px',
    },
    content: {
      fontSize: '14px',
    },
    notFoundSVG: {
      width: '330px',
    },
  },
}))

const NotFound = () => {
  const {
    NotFound,
    header,
    title,
    contentWrapper,
    subtitle,
    ctaRedirect,
    notFoundSVG,
  } = useStyles()
  const translate = useTranslate()

  return (
    <div className={NotFound}>
      <div className={header}>
        <Logo width="135" height="44" alt="Logo" />
      </div>
      <div className={contentWrapper}>
        <div className={notFoundSVG}>
          <NotFoundSVG width="100%" height="auto" />
        </div>
        <p className={title}>{translate('notFound.title')}</p>
        <p className={subtitle}>{translate('notFound.subtitle')}</p>
        <a className={ctaRedirect} href="/">
          {translate('notFound.button')}
        </a>
      </div>
    </div>
  )
}

export default NotFound
